import React from 'react';
import { Box, Stack } from '@mui/material';
import { LocaleSwitcher } from '../../../i18n/components/LocaleSwitcher';
import { Notifications, Profile } from '../Functions';
import { NavBarWelcome } from './NavBarWelcome';

interface INavBarDesktopActionsProps {
  isJobPosting: boolean;
  userName: string;
  formattedDate: string;
}

export const NavBarDesktopActions = ({
  isJobPosting,
  userName,
  formattedDate,
}: INavBarDesktopActionsProps) => {
  return (
    <Stack
      direction='row'
      alignItems='center'
      spacing={1}
      sx={{
        display: { xs: 'none', lg: 'flex' },
      }}
    >
      {!isJobPosting && (
        <NavBarWelcome userName={userName} formattedDate={formattedDate} />
      )}

      {!isJobPosting && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 2,
            p: 0.5,
            transition: 'background-color 0.2s ease',
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.08)',
            },
          }}
        >
          <Notifications />
        </Box>
      )}

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 2,
          p: 0.5,
          transition: 'background-color 0.2s ease',
          '&:hover': {
            bgcolor: 'rgba(255, 255, 255, 0.08)',
          },
        }}
      >
        <LocaleSwitcher variant='navbar' />
      </Box>

      {!isJobPosting && (
        <Box
          sx={{
            borderRadius: '50%',
            transition: 'transform 0.2s ease',
            '&:hover': {
              transform: 'scale(1.04)',
            },
          }}
        >
          <Profile />
        </Box>
      )}
    </Stack>
  );
};
